/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Password } from '../models/Password';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaAuthService {
    /**
     * Refresh access token
     * @returns any Successful authentication
     * @throws ApiError
     */
    public static refreshAccessToken({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Refresh token from previous authentication.
             */
            refresh_token: string;
        },
        apiVersion?: number,
    }): CancelablePromise<{
        /**
         * The access token to use for authenticated requests
         */
        access_token?: string;
        /**
         * The type of the access token
         */
        token_type?: 'Bearer';
        /**
         * Unix epoch timestamp indicating when the access token will expire and no longer be valid for authentication
         */
        expires?: number;
        /**
         * Token expiration in seconds
         */
        expires_in?: number;
        /**
         * Refresh token
         */
        refresh_token?: string;
        /**
         * Assigned scopes
         */
        scope?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/oauth/refreshAccessToken',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Revoke refresh token
     * @returns void
     * @throws ApiError
     */
    public static revokeRefreshToken({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Refresh token from previous authentication.
             */
            refresh_token: string;
        },
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/oauth/revokeRefreshToken',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Authenticate a user and obtain an access token
     * This endpoint allows you to authenticate user in GSOA.
     * @returns any Successful authentication
     * @throws ApiError
     */
    public static userAuth({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * The username of the user to authenticate.
             */
            username: string;
            password: Password;
        },
        apiVersion?: number,
    }): CancelablePromise<{
        /**
         * The access token to use for authenticated requests
         */
        access_token?: string;
        /**
         * The type of the access token
         */
        token_type?: 'Bearer';
        /**
         * Unix epoch timestamp indicating when the access token will expire and no longer be valid for authentication
         */
        expires?: number;
        /**
         * Token expiration in seconds
         */
        expires_in?: number;
        /**
         * Refresh token
         */
        refresh_token?: string;
        /**
         * Assigned scopes
         */
        scope?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/oauth/userAuth',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Either Invalid or Bad request`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
